// predefined imports
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Footer } from '../Footer';
import { Header } from '../Header';

// local imports

// style imports
import styles from './Layout.module.scss';

export const Layout = ({ children, noHeader = false, noFooter = false }) => {
  const history = useHistory();
  const location = useLocation();
  const profileStatus = useSelector((state) => state.profile.statusAndMsg);

  useEffect(() => {
    if (profileStatus === null && location.pathname !== '/start' && location.pathname !== '/login') {
      history.push('/start');
    }
    if (profileStatus && location.pathname !== '/start' && location.pathname !== '/login') {
      if (profileStatus.msg === 'Not Found' && profileStatus.code === 5001) {
        history.push('/no-profile');
      }
    }
  }, [profileStatus]);

  return (
    <div className={styles.layout}>
      {!noHeader && <Header />}
      <main>
        {children}
      </main>
      {!noFooter && <Footer />}
    </div>);
};

Layout.propTypes = {
  children: PropTypes.element,
  noHeader: PropTypes.bool,
  noFooter: PropTypes.bool,
};

Layout.defaultProps = {
  children: null,
  noHeader: false,
  noFooter: false
};
